import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GenerateLensCuttingMachineIntegrationFileOutput } from './GenerateLensCuttingMachineIntegrationFileOutput';

export class GenerateLensCuttingMachineIntegrationFileService extends HttpServiceBase {

  handle = (orderId: number): Promise<Result<GenerateLensCuttingMachineIntegrationFileOutput> | null> => {
    const input = { orderId };
    const promise = this.http.post<Result<GenerateLensCuttingMachineIntegrationFileOutput>, any>(
        `${this.baseUrlSislogApi}/v2/lens-cutting-cachine-integration/integration-file-generation-request`, input);
    return promise;
  }
}